import React, { useEffect, useState } from 'react';
import axios from 'axios';
import HiddenPageNotice from './HiddenPageNotice';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Route-level wrapper that renders <HiddenPageNotice /> when the admin has
 * hidden the given page slug (public GET /api/site-pages/{slug} returns 404).
 * Otherwise renders the child page normally.
 */
const PageGuard = ({ slug, children }) => {
  const [status, setStatus] = useState('loading'); // loading | visible | hidden

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/site-pages/${slug}`)
      .then(() => !cancelled && setStatus('visible'))
      .catch((err) => {
        if (cancelled) return;
        setStatus(err?.response?.status === 404 ? 'hidden' : 'visible');
      });
    return () => { cancelled = true; };
  }, [slug]);

  if (status === 'hidden') return <HiddenPageNotice />;
  // 'loading' — render the child immediately (page has its own defaults),
  // avoids a full-screen spinner and layout flash.
  return children;
};

export default PageGuard;
